import type { AtlasCell, PackCropCells } from "./types";

// Shelf packing: cells fill a row left to right and a new row starts when the next one would not fit.
export const packCropCells: PackCropCells = ({ sides, maxWidth }) => {
  const cells: AtlasCell[] = [];
  let x = 0;
  let y = 0;
  let rowHeight = 0;
  let width = 0;

  for (const side of sides) {
    if (x > 0 && x + side > maxWidth) {
      y += rowHeight;
      x = 0;
      rowHeight = 0;
    }
    cells.push({ x, y, side });
    x += side;
    rowHeight = Math.max(rowHeight, side);
    width = Math.max(width, x);
  }

  return { cells, width, height: y + rowHeight };
};
